module.exports = __webpack_public_path__ + "static/media/api.c91380ef.jpg";